import React from 'react';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import { useStateValue } from '../../providers/StateProvider';
import AvisoAuditor from '../../components/avisoPrivacidad/AvisoAuditor';
import privacy from '../../animations/lottie/privacy.json';
import AvisoEntidad from '../../components/avisoPrivacidad/AvisoEntidad';

const AvisoPrivacidad = () => {
    const [{ lvl }] = useStateValue();
    return (
        <div className="d-flex flex-column justify-content-center align-items-center">
            <h2>Aviso de privacidad</h2>
            <div className="container p-3 p-md-0 ">
                <div className="row align-items-center">
                    <div className="col-12 col-md-6 text-center m-0 p-0 d-none d-md-block">
                        <Lottie
                            className="m-0 p-0 estilo"
                            loop
                            animationData={privacy}
                            play
                        />

                    </div>
                    <div className="col-12 col-md-6 p-0">
                        {lvl === '1' ? <AvisoEntidad /> : <AvisoAuditor />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AvisoPrivacidad;
